export default "__VITE_ASSET__94df96ec__"